import styled from 'styled-components';

import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';

import { POPUP_Z_INDEX_MODAL } from '../Popup/Popup.styles';

import { InfoTextButtonThemeColor, infoTextButtonThemes, infoTextButtonTooltipThemes } from './InfoTextButton.theme';

export const IIcon = styled(StyledTypo.Typography)`
  display: block;
  font-weight: ${props => props.theme.fontWeight.bold};
  line-height: 0;
`;

export const BtnInfoText = styled.button<{ $themeColor: InfoTextButtonThemeColor; $isSmall: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${props => (props.$isSmall ? 16 : 20)}px;
  height: ${props => (props.$isSmall ? 16 : 20)}px;
  padding: 0;
  margin: -5px 6px -3px;
  vertical-align: middle;
  cursor: help;
  background-color: ${props =>
    props.theme.color[
      props.$themeColor === Color.Blue_1000_Deep
        ? infoTextButtonThemes[props.$themeColor].background.hover
        : infoTextButtonThemes[props.$themeColor].background.normal
    ]};
  border: none;
  border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '99999px')};
  transition: background-color ${props => props.theme.transitionTiming};
  @media print {
    display: none;
  }

  &:hover {
    background-color: $background-color-hover;
  }

  ${IIcon} {
    color: ${props => props.theme.color[infoTextButtonThemes[props.$themeColor].text]};
  }
`;

interface InfoTooltipProps {
  $themeColor: InfoTextButtonThemeColor;
  $customDesktopMaxWidth?: number;
}

export const InfoTooltip = styled.div<InfoTooltipProps>`
  ${StyledTypo.uiTextCss}
  z-index: ${POPUP_Z_INDEX_MODAL + 1};
  width: ${({ $customDesktopMaxWidth }) => ($customDesktopMaxWidth ? `${$customDesktopMaxWidth}px` : 'auto')};
  padding: 8px 12px;
  overflow-x: hidden;
  overflow-y: auto;
  color: ${props => props.theme.color[infoTextButtonTooltipThemes[props.$themeColor].text]};
  white-space: normal;
  background-color: ${props => props.theme.color[infoTextButtonTooltipThemes[props.$themeColor].background]};
  border-radius: ${props => props.theme.borderRadius.small};
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 2%);
  @media (${props => props.theme.breakpoint.md.up}) {
    width: ${props => props.$customDesktopMaxWidth ?? 352}px;
  }
  @media (${props => props.theme.breakpoint.sm.down}) {
    left: 0;
  }
`;
